const rhymesMap = {
  "大安": "大安: 大安事事昌,求财在坤方,失物去不远,宅舍保安康\n断曰: 行人身未动,病者主无妨,将军回田野,仔细更推详\n(大安 身不动 属木 青龙 谋事一五七)",
  "留连": "留连: 留连事难成,求谋日未明,官事只宜缓,去者未回程\n断曰: 失物南方见,急讨方趁心,更须防口舌,人口且平平\n(留连 卒未归 属水 玄武 谋事二八十)",
  "速喜": "速喜: 速喜喜来临,求财向南行,失物申午未,逢人路上寻\n断曰: 官事有福德,病者无祸侵,田宅六畜吉,行人有信音\n(速喜 人便至 属火 朱雀 谋事三六九)",
  "赤口": "赤口: 赤口主口舌,是非要紧防,失物速速讨,行人有惊慌\n断曰: 六畜多作怪,病者出西方,更须防咒嘴,诚恐染瘟肓\n(赤口 官事凶 属金 白虎 谋事四七十)",
  "小吉": "小吉: 小吉最吉昌,路上好商量,阴人来报喜,失物在坤方\n断曰: 行人即便至,交关甚是强,凡事皆合和,病者叩穹苍\n(小吉 人来喜 属木六合 谋事一五七)",
  "空亡": "空亡: 空亡事不祥,阴人少乖张,求财无利益,行人有灾殃\n断曰: 失物寻不见,官事有刑伤,病人逢暗鬼,解禳保平安\n(空亡 音信稀 属土 勾陈 谋事三六九)"
};
export default rhymesMap;